export const GET_CURRENT_LOCATIONS = 'GET_CURRENT_LOCATIONS';
export const GET_LOCATION = 'GET_LOCATION';
export const UPDATED_LOCATION = 'UPDATED_LOCATION';

export default {
  GET_CURRENT_LOCATIONS,
  GET_LOCATION,
  UPDATED_LOCATION,
};
